module.exports = __webpack_public_path__ + "media/images/icons/country_flags/eac-2f2a614596257c8a9f264ed262d04f5f.svg";